/**
 * Wraps a real platform screenshot in a clean browser-style frame.
 * Screenshots live in /public/screenshots.
 */
interface AppScreenshotProps {
  src: string;
  alt: string;
  label?: string;
  className?: string;
}

export const AppScreenshot = ({ src, alt, label, className }: AppScreenshotProps) => {
  return (
    <figure
      className={`overflow-hidden rounded-xl border border-border bg-card shadow-[0_12px_32px_hsl(220_20%_16%/0.10)] ${className ?? ""}`}
    >
      <div className="flex items-center gap-1.5 border-b border-border bg-secondary/60 px-4 py-3">
        <span className="h-2.5 w-2.5 rounded-full bg-border" />
        <span className="h-2.5 w-2.5 rounded-full bg-border" />
        <span className="h-2.5 w-2.5 rounded-full bg-border" />
        {label && <span className="ml-3 truncate text-xs text-muted-foreground">{label}</span>}
      </div>
      <img src={src} alt={alt} loading="lazy" className="block w-full" />
    </figure>
  );
};
